<template>
  <ChatModal name="forward-to" :title="$t('chat.actions.forward')" @before-open="beforeOpen">
    <div slot="default" :class="$style.container">
      <Spinner v-if="isLoading" />
      <template v-else>
        <SearchInput v-model="searchQuery" :class="$style.searchInput" @clear="resetQuery" />
        <div :class="$style.list">
          <ChatListItem
            v-for="chat in displayList"
            :key="chat.id"
            :chat="chat"
            @click.native="handleForwardMessage(chat.id)"
          />
        </div>
      </template>
    </div>
  </ChatModal>
</template>

<script>
import ChatModal from './ChatModal'
import ChatListItem from '@/views/Messenger/chat/ChatListItem'
import Spinner from '@/components/Spinner'
import { mapGetters, mapActions } from 'vuex'
import SearchInput from '@/components/SearchInput'
import { TYPE_CODE } from '@/models/Message'
import { pick } from 'lodash'
import { chatNamesForBridge } from '@/helpers/variables'

export default {
  name: 'forward-to-popup',
  components: {
    ChatModal,
    ChatListItem,
    Spinner,
    SearchInput
  },
  data () {
    return {
      messageIdList: [],
      isLoading: false,
      onClose: null,
      searchQuery: '',
      provider: ''
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      chatList: 'entities/chats/myChats',
      matrixChats: 'matrix/rooms',
      messageById: 'entities/messages/getById',
      searchChats: 'entities/chats/search'
    }),
    displayList () {
      const searchQuery = this.searchQuery.toLowerCase()
      if (this.provider === 'matrix') {
        return this.availableMatrixChats.filter(e => {
          return e.name.toLowerCase().includes(searchQuery)
        })
      } else {
        if (!searchQuery) return this.chatList
        return this.chatList.filter(e => {
          if (e.type === 1) {
            return e.name.toLowerCase().includes(searchQuery)
          } else {
            const secondChatUser = e.participants.filter(t => t.userId !== this.user.id)
            return secondChatUser[0].user.displayName.toLowerCase().includes(searchQuery)
          }
        })
      }
    },
    orderedMessageList () {
      return this.messageIdList.map(id => this.messageById(id)).sort((a, b) => a.created - b.created)
    },
    availableMatrixChats () {
      return this.matrixChats.filter(
        e => e.name !== chatNamesForBridge.whatsapp && e.name !== chatNamesForBridge.telegram && e.maySendMessage
      )
    }
  },
  methods: {
    ...mapActions({
      sendMessage: 'entities/messages/send'
    }),
    beforeOpen ({ params: { messageIdList, onClose, provider = '', selectedMessage = null } }) {
      this.resetQuery()
      this.messageIdList = messageIdList
      this.onClose = onClose
      this.provider = provider
      this.isLoading = false
    },
    resetQuery () {
      this.searchQuery = ''
    },
    async handleForwardMessage (chatId) {
      this.provider === 'matrix' ? await this.sendText(chatId) : await this.forwardMessages(chatId)
    },
    async forwardMessages (chatId) {
      this.isLoading = true
      for (let message of this.orderedMessageList) {
        let forwardedMsg
        if (message.type === TYPE_CODE.forward) {
          forwardedMsg = message.payload
          if (message.attachment) {
            forwardedMsg.attachment = message.attachment
          }
        } else {
          forwardedMsg = message
        }
        const payload = pick(forwardedMsg, ['id', 'chatId', 'type', 'payload', 'senderId', 'created'])
        if (!payload.payload) {
          delete payload.payload
        }
        payload.name = forwardedMsg.name || forwardedMsg.sender.displayName
        const data = {
          type: TYPE_CODE.forward,
          payload
        }
        if (forwardedMsg.attachment) {
          data.attachment = message.attachment
        }
        await this.sendMessage({
          chatId,
          ...data
        })
      }
      this.isLoading = false
      this.onClose()
      this.$modal.hide('forward-to')
    },
    async sendText (chatId) {
      const { type, content } = this.messageIdList[0]

      await window.matrixSDK.sendEvent(chatId, type, content, '')
      this.isLoading = false
      this.onClose()
      this.$modal.hide('forward-to')
    }
  }
}
</script>

<style lang="scss" module>
.container {
  // padding: 20px 0;
  padding-bottom: 15px;
}

.list {
  height: 400px;
  overflow-y: scroll;
}
</style>
